<template>
    <div id="">

    </div>
</template>

<script>
export default {
    name: "Error404View",
    props: {},
    components: {},
    data(){
      return {};
    },
    created() {},
    computed: {},
    methods: {}
}
</script>

<style lang="scss" scoped></style>